import { render, staticRenderFns } from "./CustomerSpecialPricesModal.vue?vue&type=template&id=94637c16&scoped=true&"
import script from "./CustomerSpecialPricesModal.vue?vue&type=script&lang=js&"
export * from "./CustomerSpecialPricesModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSpecialPricesModal.vue?vue&type=style&index=0&id=94637c16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94637c16",
  null
  
)

export default component.exports